<template>
	<div class="operation_box">
		<div class="operation_item">
			<md-button v-if="canCancel"
					   class="md-block"
					   @click="showCancelModal">
				{{ $t("seller.sell.TransactionBtn") }}
			</md-button>
		</div>
	</div>
</template>
<script>
import {enumDef} from "@/common/enumDefs";

export default {
	computed: {
		canCancel() {
			let { data } = this.params;
			return (data.status === enumDef.auctionStatus.Public || data.status === enumDef.auctionStatus.Selling) && !data.expired;
		}
	},
	methods: {
		showCancelModal() {
			let { data } = this.params;
			this.params.showCancelModal(data);
		}
	}
};
</script>